export function HuiTabList() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        controller: () => {
        },
        bindToController: {
            variant: '@'
        },
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
               <div class="hui-tab-list"
                    ng-class="[$huiCtrl.variant || 'ghost']"   
                    ng-transclude>
               </div>
            `;
        }
    }
}